import { collections, type Collection } from "./collections";

export type Product = {
  id: string;
  slug: string;
  name: string;
  collectionSlug: string;
  priceGbp: number;
  summary: string;
  details: string;
  motif: "ring" | "necklace" | "earring" | "bracelet";
};

/**
 * Public catalogue. Keep this empty until real names, prices and details
 * are confirmed. Do not add reviews, stock counts or material claims
 * unless they are verified.
 *
 * Product and collection templates remain in the React pages.
 */
export const products: Product[] = [];

export function getProduct(slug: string): Product | undefined {
  return products.find((product) => product.slug === slug);
}

export function productsInCollection(slug: string): Product[] {
  return products.filter((product) => product.collectionSlug === slug);
}

export function collectionForProduct(product: Product): Collection | undefined {
  return collections.find((collection) => collection.slug === product.collectionSlug);
}

export function catalogueIsLive(): boolean {
  return products.length > 0;
}
